module.exports = __webpack_public_path__ + "img/pg.8109dff9.svg";